import { GET_SHIBEI_PRICE_INFO } from '@/api/MaterialApi'
import { formatterPrice } from '@/tools'

import { Button, Form, InputNumber, message } from 'antd'
import { FormInstance } from 'antd/es/form'
import { useState } from 'react'

interface Props {
  value?: string
  onChange?: (value: number) => void
  form: FormInstance
  outerForm: FormInstance
}

const PriceItem = (props: Props) => {
  const [priceLoading, setPriceLoading] = useState<boolean>(false)
  const { form, value, onChange, outerForm } = props

  const priceWatch = Form.useWatch('inputExternalPrice', form)

  const onConfirmModal = async () => {
    if (!outerForm.getFieldValue('marketprice')) {
      message.warn('市场价必填')
      return
    }
    const data = form.getFieldsValue()

    setPriceLoading(true)
    // 获取链接价格
    const res = await GET_SHIBEI_PRICE_INFO({
      externalNum: data.externalNum,
      internalNum: data.internalNum,
      url: data.externalLink,
      marketPrice: outerForm.getFieldValue('marketprice'),
      platformType: data.platformType,
    })

    if (res.code === 0) {
      setPriceLoading(false)

      const result = res.data
      const salePrice =
        result && typeof result === 'object' ? result.salePrice : result
      onChange && onChange(Number(formatterPrice(salePrice)))
      if (
        result &&
        typeof result === 'object' &&
        result.commentCount !== undefined &&
        result.commentCount !== null
      ) {
        form.setFieldValue('commentCount', result.commentCount)
      } else if (result && typeof result === 'object') {
        message.warning('评论/销量获取失败，请手工填写')
      }
    } else {
      message.error(res.msg)
      setPriceLoading(false)
    }
  }

  return (
    <>
      <InputNumber
        placeholder="请输入"
        min={0}
        max={99999.99}
        precision={2}
        style={{ width: 150 }}
        value={Number(value)}
        onChange={(val) => {
          // @ts-ignore
          onChange && onChange(val ?? '')
        }}
      />
      <Button
        type="primary"
        size="small"
        style={{ margin: '0px 10px' }}
        onClick={onConfirmModal}
        loading={priceLoading}
        disabled={!!priceWatch}
      >
        获取价格
      </Button>
    </>
  )
}

export default PriceItem
import { GET_SHIBEI_PRICE_INFO } from '@/api/MaterialApi'
import { formatterPrice } from '@/tools'

import { Button, Form, InputNumber, message } from 'antd'
import { FormInstance } from 'antd/es/form'
import { useState } from 'react'

interface Props {
  value?: string
  onChange?: (value: number) => void
  form: FormInstance
  outerForm: FormInstance
}

const PriceItem = (props: Props) => {
  const [priceLoading, setPriceLoading] = useState<boolean>(false)
  const { form, value, onChange, outerForm } = props

  const priceWatch = Form.useWatch('inputExternalPrice', form)

  const onConfirmModal = async () => {
    if (!outerForm.getFieldValue('marketprice')) {
      message.warn('市场价必填')
      return
    }
    const data = form.getFieldsValue()

    setPriceLoading(true)
    // 获取链接价格
    const res = await GET_SHIBEI_PRICE_INFO({
      externalNum: data.externalNum,
      internalNum: data.internalNum,
      url: data.externalLink,
      marketPrice: outerForm.getFieldValue('marketprice'),
      platformType: data.platformType,
    })

    if (res.code === 0) {
      setPriceLoading(false)

      const result = res.data
      const salePrice =
        result && typeof result === 'object' ? result.salePrice : result
      onChange && onChange(Number(formatterPrice(salePrice)))
      if (
        result &&
        typeof result === 'object' &&
        result.commentCount !== undefined &&
        result.commentCount !== null
      ) {
        form.setFieldValue('commentCount', result.commentCount)
      } else if (result && typeof result === 'object') {
        message.warning('评论/销量获取失败，请手工填写')
      }
    } else {
      message.error(res.msg)
      setPriceLoading(false)
    }
  }

  return (
    <>
      <InputNumber
        placeholder="请输入"
        min={0}
        max={99999.99}
        precision={2}
        style={{ width: 150 }}
        value={Number(value)}
        onChange={(val) => {
          // @ts-ignore
          onChange && onChange(val ?? '')
        }}
      />
      <Button
        type="primary"
        size="small"
        style={{ margin: '0px 10px' }}
        onClick={onConfirmModal}
        loading={priceLoading}
        disabled={!!priceWatch}
      >
        获取价格
      </Button>
    </>
  )
}

export default PriceItem
